import type { FC } from 'react'

import { getQueryFilter } from '@skytech/utils'

import { Translation } from '@/app/translations/Translation'
import { NoResults } from '@/components/NoResults'
import { ResultCount } from '@/components/ResultCount'
import { useAdminAccess } from '@/hooks/access'
import { useRenderLimit } from '@/hooks/use-render-limit'

import type { TextTemplate } from '../resources'

import { TextTemplateListItem } from './TextTemplateListItem'

export const TextTemplateList: FC<{
  searchFilter: string
  textTemplateList: TextTemplate[]
  onClickTextTemplateRow: (id: number) => void
}> = ({ searchFilter, textTemplateList, onClickTextTemplateRow }) => {
  useAdminAccess()

  const stringMatcher = (item: TextTemplate) => [
    item.code,
    item.subject,
    item.description,
    item.text,
    item.type,
  ]
  const itemsFiltered = textTemplateList?.filter(getQueryFilter(searchFilter, stringMatcher)) || []
  const { visibleList, ListLoaderComponent } = useRenderLimit(itemsFiltered, 30)

  return (
    <>
      <ResultCount count={itemsFiltered.length} />
      {itemsFiltered.length > 0 ? (
        <table>
          <thead>
            <tr>
              <th className="hidden md:table-cell">
                <Translation id="code" />
              </th>
              <th>
                <Translation id="Subject" />
              </th>
              <th className="hidden md:table-cell">
                <Translation id="text" />
              </th>
            </tr>
          </thead>
          <tbody>
            {visibleList.map(({ id, ...rest }) => (
              <TextTemplateListItem
                key={id}
                searchFilter={searchFilter}
                onEdit={() => onClickTextTemplateRow(id)}
                {...rest}
              />
            ))}
          </tbody>
        </table>
      ) : (
        <NoResults />
      )}
      <ListLoaderComponent />
    </>
  )
}
